import moment from "moment";
import { useAppDispatch } from "@store";
import { setEndDate, setStartDate } from "@store/date/dateSlice";

export interface MonthPeriodNavigation {
  currentMonth: string;
  onPressLeftPeriod: () => void;
  onPressRightPeriod: () => void;
}

export const useMonthPeriodNavigation = (startDate: string): MonthPeriodNavigation => {
  const dispatch = useAppDispatch();

  const currentMonth = `${moment(startDate).format("MMMM").toUpperCase()} ${moment(startDate).format("YYYY")}`;

  const onPressLeftPeriod = () => {
    const start = moment(startDate).subtract(1, "month").startOf("month").format("YYYY-MM-DD");

    const end = moment(startDate).subtract(1, "month").endOf("month").format("YYYY-MM-DD");

    dispatch(setStartDate(start));
    dispatch(setEndDate(end));
  };

  const onPressRightPeriod = () => {
    const start = moment(startDate).add(1, "month").startOf("month").format("YYYY-MM-DD");

    const end = moment(startDate).add(1, "month").endOf("month").format("YYYY-MM-DD");

    dispatch(setStartDate(start));
    dispatch(setEndDate(end));
  };

  return { currentMonth, onPressLeftPeriod, onPressRightPeriod };
};
